const translations = {
    contactName: 'Contact Name',
    email: 'Email',
    loading: 'Loading...',
    name: 'Name',
    noClients: 'No clients',
    noMoreClients: 'No more clients',
    phone: 'Phone'
};

export default translations;
